import { AfterViewInit, Component, ContentChild, ElementRef, EventEmitter, HostBinding, Input, Output, TemplateRef } from '@angular/core';

import interact_ from 'interactjs';
const interact: any = interact_;

export interface UiLegendBoxItem {
  title: string;
  items:
    | Array<{
        label: string;
        color?: string;
        size?: number;
      }>
    | number;
  type?: string;
}

export enum UILegendRowType {
  CIRCLE = 'circle',
  BAR = 'bar',
  SIZE = 'size',
  LINE = 'line'
}

@Component({
  selector: 'ui-legend-box',
  templateUrl: './legend-box.component.html',
  styleUrls: ['./legend-box.component.scss']
})
export class LegendBoxComponent implements AfterViewInit {
  @Input()
  set data(rows: Array<UiLegendBoxItem>) {
    if (rows) {
      this.rows = rows
        .map((row) => {
          //  If is not an array and is a number we generate and array
          if (!Array.isArray(row.items)) {
            const numItems = row.items ? row.items : 0;
            row.items = new Array(numItems).fill('').map((d) => d);
          }
          return row;
        })
        .filter((row) => !!(row.items as Array<any>).length);
    }
  }

  @Input()
  minimizedOnInit: boolean;

  @Output()
  onToggle: EventEmitter<boolean> = new EventEmitter<boolean>();

  @HostBinding('class.closed')
  public collapsed: boolean = false;

  @ContentChild('optionsList')
  optionsListTmpl: TemplateRef<any>;

  @ContentChild('iconCollapsed')
  iconCollapsedTmpl: TemplateRef<any>;

  // there is no typing here because this will be an interact.js object
  private interactElm;
  private draggableElm: HTMLElement;
  public rows: Array<UiLegendBoxItem> = [];

  constructor(private readonly hostDom: ElementRef) {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.draggableElm = this.hostDom.nativeElement;
      this.interactElm = this.initDraggable();

      if (this.minimizedOnInit) {
        this.close();
      }
    }, 0);
  }

  public close() {
    this.collapsed = true;
    this.onToggle.emit(this.collapsed);
    //  ON close the box remove draggable events to the element to allow click
    this.interactElm.unset();
  }

  public open(event) {
    event.stopPropagation();
    this.collapsed = false;

    this.onToggle.emit(this.collapsed);
    //  ON open the box remove draggable events to the element to allow click
    this.interactElm = this.initDraggable();
  }

  public initDraggable() {
    const interactElm = interact(this.draggableElm);

    interactElm.draggable({
      inertia: false,
      restrict: {
        // keep the element within the area of it's parent
        restriction: 'parent',
        endOnly: false,
        elementRect: {
          top: 0,
          left: 0,
          bottom: 1,
          right: 1
        }
      },
      // enable autoScroll
      autoScroll: true,
      onmove: (event) => {
        const target = event.target;
        // keep the dragged position in the data-x/data-y attributes
        const y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        const x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;

        // update the position attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);

        // translate the element
        target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
      }
    });
    return interactElm;
  }
}
